import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import moment from 'moment';
import { groupBy, values, filter, defer } from 'lodash';
import {
  OverlayTrigger, Tooltip, Tab, Tabs,
} from 'react-bootstrap';

import DateTimeDisplay from '../../../../components/date-time-display';
import MoneyDisplay from '../../../../components/money-display';
import NumberDisplay from '../../../../components/number-display';
import GradientWrapper from '../../../../components/gradient-wrapper';
import AccountNameRenderer from '../../../../components/table-cells/AccountNameRenderer';
import { getSavedSearches } from '../../../../components/search-form/search-form-reducer';
import RainbowText from '../../../../components/rainbow-text';
import AccountLogo from '../account-logo';
import RequestTab from './RequestTab';
import FeedbackTab from './FeedbackTab';
import SellerReasonTab from './SellerReasonTab';
import InternalEmailTab from './InternalEmailTab';
import ExcludeOpportunityForm from './ExcludeOpportunityForm';
import OpportunityRow from './OpportunityRow';
import { getTablePreference } from '../../../App/AppReducer';
import { getTVProductDictionary } from '../../../Setup/SetupReducer';
import { getColumnData } from '../../../../components/god-table/reducer';
import { getWinLossOpportunitySurveys, getWinLossOpportunityInternalEmails, getFeedbackRequestStatus } from '../../../Dashboard/DashboardReducer';

import styles from './styles.css';
import ActionButton from './ActionButton';

const FEEDBACK_TAB = 'feedbacks';
const SELLER_TAB = 'sellers';
const REQUEST_TAB = 'requests';
const INTERNAL_EMAIL_TAB = 'internal_emails';

class OpportunityBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandPeopleAi: false,
    };
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleOnLogoLoaded = this.handleOnLogoLoaded.bind(this);
    this.requestAddOpportunitySurvey = this.requestAddOpportunitySurvey.bind(this);
    this.requestRunTest = this.requestRunTest.bind(this);
    this.requestSendSummaryEmail = this.requestSendSummaryEmail.bind(this);
    this.requestSendReminderEmail = this.requestSendReminderEmail.bind(this);
    this.excludeOpportunity = this.excludeOpportunity.bind(this);
    this.includeOpportunity = this.includeOpportunity.bind(this);
    this.requestShowOutreachPlan = this.requestShowOutreachPlan.bind(this);
    this.requestChangeSenderEmail = this.requestChangeSenderEmail.bind(this);
    this.requestChangeCommnunicationRecipient = this.requestChangeCommnunicationRecipient.bind(this);
    this.requestChangeLanguage = this.requestChangeLanguage.bind(this);
    this.handleRequestShowSellerAttribute = this.handleRequestShowSellerAttribute.bind(this);
    this.requestAddOpportunitySurveyForContact = this.requestAddOpportunitySurveyForContact.bind(this);
    this.requestPauseReminderEmail = this.requestPauseReminderEmail.bind(this);
    this.handleMeasure = this.handleMeasure.bind(this);
    this.toggleShowAIPeople = this.toggleShowAIPeople.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isVisible !== nextProps.isVisible && nextProps.isVisible) {
      this.handleMeasure(true);
    } else if (this.props.isScrolling !== nextProps.isScrolling && !nextProps.isScrolling) {
      this.handleMeasure(true);
    }
  }

  handleMeasure(force = false) {
    if ((!this.props.isScrolling && this.props.isVisible) || force) {
      this.props.measure();
    }
  }

  toggleShowAIPeople() {
    // just to toggle refresh state, not storing real value
    this.setState({ expandPeopleAi: !this.state.expandPeopleAi }, () => {
      defer(() => {
        this.handleMeasure();
      });
    });
  }

  getColors() {
    const { colorPallete } = this.props;
    const primaryColor = colorPallete ? colorPallete.vibrant : null;
    const secondaryColor = colorPallete ? colorPallete.darkVibrant || colorPallete.darkMuted : null;
    return { primaryColor, secondaryColor };
  }

  getFeedbacks() {
    // per contact
    const { opportunity } = this.props;
    let reasons = [];
    if (opportunity.has_feedbacks && opportunity.feedbacks) {
      /*
      reasons = values(groupBy(filter(opportunity.feedbacks, { is_client: true }), 'contact_id'));
      if (reasons.length === 0) {
        reasons = values(groupBy(filter(opportunity.feedbacks, { has_no_impacts: true }), 'contact_id'));
      }
      */
      reasons = values(groupBy(filter(opportunity.feedbacks, (fb) => {
        return fb.is_client === true || fb.has_no_impacts === true;
      }), 'contact_id'));
    }
    return reasons;
  }

  requestAddOpportunitySurvey(e) {
    if (e) {
      e.preventDefault();
    }
    const { opportunity } = this.props;
    this.props.requestAddOpportunitySurvey(opportunity);
    this.props.onTabSelect(REQUEST_TAB);
  }

  requestRunTest(e) {
    const { opportunity } = this.props;
    if (e.preventDefault) {
      e.preventDefault();
      this.props.requestRunTest(opportunity);
    } else {
      this.props.requestRunTest(opportunity, e._id);
    }
  }

  requestSendSummaryEmail(automation) {
    const { opportunity } = this.props;
    this.props.requestSendSummaryEmail(opportunity, automation._id);
  }

  requestSendReminderEmail(automation) {
    const { opportunity } = this.props;
    this.props.requestSendReminderEmail(opportunity, automation._id);
  }
  

  requestAddOpportunitySurveyForContact(contact) {
    this.props.onTabSelect(REQUEST_TAB);
    const { opportunity } = this.props;
    this.props.requestAddOpportunitySurvey(opportunity, contact);
  }


  requestPauseReminderEmail(pause = false) {
    const { opportunity } = this.props;
    return this.props.requestPauseReminderEmail(opportunity, pause);
  }

  handleTabSelect(tab) {
    this.props.onTabSelect(tab);
    defer(() => {
      this.handleMeasure();
    });
  }

  handleOnLogoLoaded(accountLogoUrl, colorPallete) {
    if (this.props.isVisible) {
      this.props.onLogoLoaded(accountLogoUrl, colorPallete);
      this.handleMeasure();
    }
  }

  requestShowOutreachPlan(survey) {
    return this.props.requestShowOutreachPlan({ ...survey, object_id: this.props.opportunity.opportunity_id });
  }

  requestChangeSenderEmail(survey) {
    return this.props.requestChangeSenderEmail({ ...survey, object_id: this.props.opportunity.opportunity_id, object: this.props.opportunity });
  }

  requestChangeCommnunicationRecipient() {
    return this.props.requestChangeCommnunicationRecipient(this.props.opportunity);
  }


  requestChangeLanguage(survey, currentLanguage, availableLanguages) {
    return this.props.requestChangeLanguage({ ...survey, object_id: this.props.opportunity.opportunity_id }, currentLanguage, availableLanguages);
  }

  handleRequestShowSellerAttribute(...params) {
    this.props.requestShowSellerAttribute(...params, this.props.opportunity);
  }

  excludeOpportunity() {
    return this.props.excludeOpportunity(this.props.opportunity);
  }

  includeOpportunity() {
    return this.props.includeOpportunity(this.props.opportunity);
  }

  

  renderStageVerb(isPast = false) {
    const { opportunity } = this.props;
    let { stage } = opportunity;
    if (opportunity.has_feedbacks && opportunity.tv_outcome) {
      const tvOutcome = opportunity.tv_outcome;
      const outcomes = {
        1: 'Win', 2: 'Lost', 3: 'No Decision', 4: 'Unknown', 5: 'Pending', 6: 'Experience',
      };
      if (outcomes[tvOutcome]) {
        stage = outcomes[tvOutcome];
      }
    }
    let stageLabel = isPast ? 'won' : 'win';
    if (stage === 'Lost') {
      stageLabel = isPast ? 'lost' : 'lose';
    } else if (stage === 'No Decision') {
      stageLabel = isPast ? 'pushed' : 'push';
    } else if (stage === 'Pending') {
      stageLabel = isPast ? 'pending' : 'pending';
    }
    return stageLabel;
  }

  renderHeader(totalRequests) {
    const { 
      opportunity, feedbackRequestStatus, 
      showRunTestButton, showSendReminderEmailButton, showSendSummaryEmailButton,
    } = this.props;
    const { account } = opportunity;
    let name = null;
    let logo = null;
    if (account) {
      name = (<AccountNameRenderer data={account} />);
      logo = (
        <AccountNameRenderer data={account}>
          <AccountLogo onLogoLoaded={this.handleOnLogoLoaded} account={account} size={48} />
        </AccountNameRenderer>
      );
    } else {
      name = (<em className="text-muted">Unknown account</em>);
    }

    let dateLabel = 'Opportunity closed';
    let dateValue = opportunity.close_date;
    let dateUrl = null;
    let dateDisplayComp = null;
    const displayCaptureDate = false;

    if (displayCaptureDate && opportunity.has_feedbacks && opportunity.publish_date) {
      dateLabel = 'Captured';
      dateValue = opportunity.publish_date;
      dateUrl = opportunity.overview_url;
      dateDisplayComp = (<DateTimeDisplay value={dateValue} relative maxRelativeDifferentDays={360} />);
    } else {
      const now = moment().startOf('day');
      const dif = now.diff(opportunity.close_date, 'days');

      if (dif === 0) {
        dateDisplayComp = (<span>today</span>);
      } else if (dif === 1) {
        dateDisplayComp = (<span>yesterday</span>);
      } else if (opportunity.close_date && opportunity.close_date.isValid()) {
        let tip = (
          <Tooltip id={`opportunity-${opportunity.opportunity_id}`}>
            <span>Opportunity closes in future date: <DateTimeDisplay value={opportunity.close_date} format="short" /></span>
          </Tooltip>
        );
        if (dif < 0) {
          dateLabel = 'Opportunity closes';
        }

        let warn = dif < 0 ? (<OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}><Fa name="exclamation-triangle" className="text-warning" /></OverlayTrigger>) : null;

        if (!opportunity.is_closed) {
          dateLabel = 'Expected closed date: ';
          tip = (
            <Tooltip id={`opportunity-${opportunity.opportunity_id}`}>
              <span>Opportunity is not yet closed</span>
            </Tooltip>
          );
          warn = (
            <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}><Fa name="exclamation-triangle" className="text-warning" /></OverlayTrigger>
          );
        }

        dateDisplayComp = (<span>{opportunity.close_date.fromNow()} {warn}</span>);
      }
    }

    let dateComp = dateValue ? (
      <span>{dateLabel}{' '}{dateDisplayComp}</span>
    ) : null;
    if (dateUrl) {
      dateComp = (
        <a target="_blank" href={dateUrl} rel="noreferrer">{dateComp}</a>
      );
    }

    return (
      <div className={styles.paddingH}>
        <div className={`${styles.bottomLine} clearfix ${styles.paddingV}`}>

          <div className={styles.accountRows}>
            <div className={styles.accountPhoto}>
              {logo !== null &&
                <div className={styles.accountPhoto}>
                  {logo}
                </div>
              }
            </div>

            <div className={styles.accountInfo}>
              <div className={styles.accountName}>
                {name}
              </div>
              <div className={styles.accountDate}>{dateComp}</div>
            </div>

            <div>
             
              {!opportunity.exclusion &&
                <div className={`${styles.headerControls} text-right`}>
                  <ActionButton
                    object={opportunity}
                    isAccount={false}
                    feedbackRequestStatus={feedbackRequestStatus}
                    requestFeedback={this.requestAddOpportunitySurvey}
                    requestExclude={() => {
                      this.props.excludeOpportunity(opportunity);
                    }}
                    requestRunTest={this.props.requestRunTest ? this.requestRunTest : null}
                    enableRunTest={showRunTestButton}
                    enableSummary={(totalRequests > 0 && showSendSummaryEmailButton)}
                    requestSendSummaryEmail={this.requestSendSummaryEmail}

                    enableReminder={showSendReminderEmailButton}
                    requestSendReminderEmail={this.requestSendReminderEmail}

                    enableChangeCommnunicationRecipient={this.props.enableChangeCommnunicationRecipient}
                    requestChangeCommnunicationRecipient={this.requestChangeCommnunicationRecipient}

                    enablePauseReminderEmail
                    requestPauseReminderEmail={this.requestPauseReminderEmail}
                  />
                </div>
              }



              <div className={`text-right ${styles.amountSection}`}>
                <MoneyDisplay currencyIsoCode={opportunity.currency_iso_code} baseValue={opportunity.base_amount} value={opportunity.amount} abbreviated />
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }

  renderExcludeMessage() {
    const { opportunity, auth } = this.props;
    if (!opportunity.exclusion) {
      return null;
    }
    return (
      <div key="exclude" className={styles.section}>
        <ExcludeOpportunityForm
          opportunity={opportunity}
          auth={auth}
          isModal={false}
          requestInclude={this.includeOpportunity}
        />
      </div>
    );
  }

  renderRows() {
    const { rows, opportunity, rowData, productDictionary, surveys } = this.props;
    const visiableRows = filter(rows, { is_visible: true });
    if (visiableRows.length === 0) {
      return null;
    }
    return (
      <div className={styles.section}>
        <table className="table table-condensed" style={{ margin: 0 }}>
          <tbody>
            {visiableRows.map((row) =>
              <OpportunityRow
                surveys={surveys}
                rowData={rowData}
                row={row}
                productDictionary={productDictionary}
                opportunity={opportunity}
                key={row._id}
                requestAddOpportunitySurveyForContact={this.requestAddOpportunitySurveyForContact}
                toggleShowAIPeople={this.toggleShowAIPeople}
              />
            )}
          </tbody>
        </table>
      </div>
    );
  }

  renderBody(_totalRequests, _totalFeedbacks) {
    const { opportunity, collectorStats } = this.props;
    const { primaryColor, secondaryColor } = this.getColors();
    const { amount, account } = opportunity;
    const stage = opportunity.tv_stage || opportunity.stage;

    // const accountComp = (<span>at <AccountNameRenderer data={account} /></span>);
    const accountComp = account ? (<span>at {account.name}</span>) : null;

    let stageWord = stage;
    if (stage === 'Won') {
      stageWord = 'win';
    } else if (stage === 'Lost') {
      stageWord = 'loss';
    } else if (stage === 'No Decision') {
      stageWord = 'no decision';
    } else if (!opportunity.is_closed) {
      stageWord = 'no decision';
    }

    let stageComp = (<strong className={styles.stage}>{stageWord}</strong>);
    const amountComp = (<strong><MoneyDisplay value={amount} abbreviated /></strong>);

    let shouldRenderBackground = false;
    let shouldRenderRainbowText = false;
    let titleComp = (
      <div>
        <strong><span>Need buyer feedback</span> for {amountComp} {stageComp} {accountComp}</strong>.
      </div>
    );

    if (opportunity.has_feedbacks) {
      let competitorComp = null;
      const stageLabel = this.renderStageVerb(true);
      if (stage !== 'No Decision') {
        if (opportunity.strongest_competitors && opportunity.strongest_competitors.length) {
          const firstCompetitor = opportunity.strongest_competitors[0];
          const competitorName = firstCompetitor.name;

          if (firstCompetitor.battlecard_url) {
            competitorComp = (<span><em>versus</em> <a href={firstCompetitor.battlecard_url} target="_blank" rel="noreferrer">{competitorName}</a></span>);
          } else {
            competitorComp = (<span><em>versus</em> {competitorName}</span>);
          }
        }
      }
      stageComp = (<strong className={styles.stage}>{stageLabel}</strong>);
      if (stageLabel === 'Pending' || stageLabel === 'pending') {
        stageComp = (<strong className={styles.stage}>pending decision</strong>);
        titleComp = (
          <div>
            <strong><span>Feedback on</span> {stageComp} {accountComp} {competitorComp}</strong>
          </div>
        );
      } else {
        titleComp = (
          <div>
            <strong><span>Primary reasons you</span> {stageComp} {accountComp} {competitorComp}</strong>
          </div>
        );
      }
      shouldRenderBackground = true;
    } else if (collectorStats.total > 0) {
      let stageLabel = stage;

      if (stage === 'Lost') {
        stageLabel = 'loss';
      } else if (stage === 'No Decision') {
        stageLabel = 'no decision';
      } else if (stage === 'Win') {
        stageLabel = 'win';
      }
      stageComp = (<strong className={styles.stage}>{stageLabel}</strong>);

      titleComp = (
        <div>
          <strong>
            <span>Requested {stageComp} feedback</span> from <NumberDisplay value={collectorStats.total} suffix="buyer" suffixIsUnit precision={0} />
          </strong>
        </div>
      );
      shouldRenderRainbowText = true;
    }

    const comp = (
      <div key="title" className={styles.section}>
        <div className={styles.mainTitle}>{titleComp}</div>
      </div>
    );

    let body = [];

    if (shouldRenderBackground) {
      body = [
        (
          <GradientWrapper
            key="main"
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            className={styles.vibrantBackground}
            onMounted={this.handleMeasure}
          >
            {comp}
          </GradientWrapper>
        ),
        this.renderExcludeMessage(),
      ];
    } else if (shouldRenderRainbowText) {
      body = [
        (
          <RainbowText
            key="main"
            id={opportunity.opportunity_id}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            className={styles.rainbowText}
            onMounted={this.handleMeasure}
          >
            {comp}
          </RainbowText>
        ),
        this.renderExcludeMessage(),
      ];
    } else {
      body = [
        (<div key="main" className={styles.plain} />),
        // comp,
        this.renderExcludeMessage(),
      ];
    }

    return (
      <div className={styles.sectionBody}>
        {body}
        {this.renderRows(!shouldRenderRainbowText && !shouldRenderBackground)}
      </div>
    );
  }

  renderTabs(feedbacks, totalRequests, totalFeedbacks,  defaultActiveKey) {
    const {
      opportunity, tab, isVisible, isLast,
      sellerReasonsEnabled, emailAutomationsEnabled, internalEmails, feedbackRequestStatus,
    } = this.props;
    if (opportunity.excluded && totalFeedbacks === 0 && totalRequests === 0) {
      return null;
    }
    const feedbackTabTitle = totalFeedbacks > 0 ? 'Buyer Reasons' : 'No Buyer Feedback';

    const totalSellerFeedbacks = opportunity.seller_feedbacks ? opportunity.seller_feedbacks.length : 0;

    const sellerTip = (
      <Tooltip id={`opportunity-seller-${opportunity.opportunity_id}`}>
        Need seller reasons &mdash;<br /><em>why did we {this.renderStageVerb(false)}?</em>
      </Tooltip>
    );

    const sellerTabTitle = opportunity.has_seller_feedback && totalSellerFeedbacks > 0
      ? 'Seller Reasons'
      : <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={sellerTip}><span>No Seller Feedback <Fa name="exclamation-triangle" className="text-warning" /></span></OverlayTrigger>;

    const requestTabTitle = totalRequests > 0
      ? <NumberDisplay value={totalRequests} suffix="request" suffixIsUnit precision={0} />
      : 'No Requests';

    const totalInternalEmails = internalEmails ? internalEmails.length : (opportunity.internal_email_count || 0);

    const internalEmailTabTitle = totalInternalEmails > 0
      ? <NumberDisplay value={totalInternalEmails} suffix="internal email" suffixIsUnit precision={0} />
      : 'No Internal Emails';
    const internalEmailTabEnabled = emailAutomationsEnabled;

    const isRequestTabActive = defaultActiveKey === REQUEST_TAB;
    const isInternalEmailTabActive = defaultActiveKey === INTERNAL_EMAIL_TAB;

    const feedbackRequestable = feedbackRequestStatus.feedbackRequestable && !feedbackRequestStatus.loading;

    return (
      <div className={` ${styles.topLine}`}>
        <Tabs
          defaultActiveKey={defaultActiveKey}
          id={`opportunity-tabs-${opportunity.opportunity_id}`}
          animation={false}
          onSelect={this.handleTabSelect}
          className={styles.tabs}
          activeKey={tab || defaultActiveKey}
          mountOnEnter
          unmountOnExit={false}
        >
          {feedbackRequestStatus.loading && <Tab title={<Fa name="spinner" spin />}></Tab>}
          {(feedbackRequestable || totalFeedbacks > 0) &&
            <FeedbackTab
              eventKey={FEEDBACK_TAB}
              title={feedbackTabTitle}
              object={opportunity}
              totalFeedbacks={totalFeedbacks}
              feedbacks={feedbacks}
              measure={this.handleMeasure}
              requestShowInsight={this.props.requestShowInsight}
            />
          }

          {sellerReasonsEnabled &&
            <SellerReasonTab
              eventKey={SELLER_TAB}
              title={sellerTabTitle}
              object={opportunity}
              totalFeedbacks={totalSellerFeedbacks}
              feedbacks={[]}
              measure={this.handleMeasure}
              requestShowInsight={this.props.requestShowInsight}
              requestAddSellerFeedback={this.props.requestAddSellerFeedback}
              requestShowAttribute={this.handleRequestShowSellerAttribute}
            />
          }
          {internalEmailTabEnabled && <InternalEmailTab
            eventKey={INTERNAL_EMAIL_TAB}
            title={internalEmailTabTitle}
            object={opportunity}
            totalInternalEmails={totalInternalEmails}
            measure={this.handleMeasure}
            isActive={isInternalEmailTabActive && isVisible}
          />}
          <RequestTab
            eventKey={REQUEST_TAB}
            title={requestTabTitle}
            object={opportunity}
            totalRequests={totalRequests}
            measure={this.handleMeasure}
            requestAddSurvey={this.props.requestAddOpportunitySurvey}
            isActive={isRequestTabActive && isVisible}
            requestShowOutreachPlan={this.requestShowOutreachPlan}
            requestChangeSenderEmail={this.requestChangeSenderEmail}
            requestChangeLanguage={this.requestChangeLanguage}
            requestCancelContact={this.props.requestCancelContact}
            surveyControlDropup={isLast}
            showAddButton={feedbackRequestable}
          />
        </Tabs>
      </div>
    );
  }

  render() {
    const { opportunity, collectorStats, tab } = this.props;
    const isExcluded = opportunity.excluded;
    const cls = [styles.box];
    if (isExcluded) {
      cls.push(styles.exclude);
    }

    const feedbacks = this.getFeedbacks();
    const totalFeedbacks = feedbacks.length;
    let totalRequests = 0;
    let defaultActiveKey = tab;

    if (totalFeedbacks > 0) {
      if (!defaultActiveKey) {
        defaultActiveKey = FEEDBACK_TAB;
      }
    }
    if (collectorStats.total) {
      totalRequests = collectorStats.total;
      if (totalFeedbacks === 0 && !defaultActiveKey) {
        defaultActiveKey = REQUEST_TAB;
      }
    }
    return (
      <div className={styles.spacing}>
        <div className={cls.join(' ')}>
          {this.renderHeader(totalRequests)}
          {this.renderBody(totalRequests, totalFeedbacks, feedbacks)}
          {this.renderTabs(feedbacks, totalRequests, totalFeedbacks, defaultActiveKey)}
        </div>
      </div>
    );
  }
}

OpportunityBox.propTypes = {
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
    name: PropTypes.string,
    has_seller_feedback: PropTypes.bool,
    internal_email_count: PropTypes.number,
    owner: PropTypes.shape({
      name: PropTypes.string,
      display_name: PropTypes.string,
    }),
    account: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  collectorStats: PropTypes.shape({}),
  measure: PropTypes.func,
  onTabSelect: PropTypes.func,
  tab: PropTypes.string,
  colorPallete: PropTypes.shape({}),
  onLogoLoaded: PropTypes.func,
  requestShowInsight: PropTypes.func,
  requestAddOpportunitySurvey: PropTypes.func,
  isVisible: PropTypes.bool,
  excludeOpportunity: PropTypes.func,
  includeOpportunity: PropTypes.func,
  auth: PropTypes.shape({}).isRequired,
  requestShowOutreachPlan: PropTypes.func,
  requestChangeSenderEmail: PropTypes.func,
  requestAddSellerFeedback: PropTypes.func,
  isLast: PropTypes.bool,
  sellerReasonsEnabled: PropTypes.bool,
  sellerReasonsFirst: PropTypes.bool,
  emailAutomationsEnabled: PropTypes.bool,
  requestChangeLanguage: PropTypes.func,
  requestCancelContact: PropTypes.func,
  requestShowSellerAttribute: PropTypes.func,
  requestRunTest: PropTypes.func,
  requestSendSummaryEmail: PropTypes.func,
  requestSendReminderEmail: PropTypes.func,
  rows: PropTypes.arrayOf(PropTypes.shape({})),
  rowData: PropTypes.shape({}),
  productDictionary: PropTypes.shape({}),
  surveys: PropTypes.arrayOf(PropTypes.shape({})),
  showRunTestButton: PropTypes.bool,
  showSendSummaryEmailButton: PropTypes.bool,
  showSendReminderEmailButton: PropTypes.bool,
  savedSearches: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  internalEmails: PropTypes.arrayOf(PropTypes.shape({})),
  feedbackRequestStatus: PropTypes.shape({}),
  requestPauseReminderEmail: PropTypes.func,
  enableChangeCommnunicationRecipient: PropTypes.bool,
  isScrolling: PropTypes.bool,
};

OpportunityBox.defaultProps = {
  collectorStats: {},
  colorPallete: {},
  measure: () => {},
  onTabSelect: () => {},
  onLogoLoaded: () => {},
  tab: null,
  requestShowInsight: () => {},
  requestAddOpportunitySurvey: () => {},
  requestRunTest: null,
  requestSendSummaryEmail: () => {},
  requestSendReminderEmail: () => {},
  isVisible: false,
  excludeOpportunity: () => {},
  includeOpportunity: () => {},
  requestChangeSenderEmail: () => {},
  requestChangeLanguage: () => {},
  requestAddSellerFeedback: () => {},
  requestShowSellerAttribute: () => {},
  requestCancelContact: () => {},
  requestShowOutreachPlan: () => Promise.reject(new Error('Need handler')),
  isLast: false,
  sellerReasonsEnabled: false,
  sellerReasonsFirst: false,
  rows: [],
  rowData: {},
  productDictionary: {},
  surveys: [],
  showRunTestButton: false,
  showSendSummaryEmailButton: false,
  showSendReminderEmailButton: false,
  enableChangeCommnunicationRecipient: false,
  savedSearches: [],
  internalEmails: null,
  feedbackRequestStatus: {},
  requestPauseReminderEmail: () => {},
  isScrolling: false,
};

function mapStateToProps(state, ownProps) {
  return {
    rows: getTablePreference(state, 'feedback-tile'),
    rowData: getColumnData(state),
    productDictionary: getTVProductDictionary(state),
    surveys: getWinLossOpportunitySurveys(state, ownProps.opportunity.opportunity_id),
    internalEmails: getWinLossOpportunityInternalEmails(state, ownProps.opportunity.opportunity_id),
    savedSearches: getSavedSearches('feedback/decisions', state),
    feedbackRequestStatus: getFeedbackRequestStatus(state, ownProps.opportunity.opportunity_id),
  };
}

export default connect(mapStateToProps)(OpportunityBox);
